import React from 'react';

const ActivitiesWaste = () => {
  return (
    <section id="activities-waste">

      <h1>Hulladékkezelés, szállítás</h1>

      <header>

        <div id="activities-waste-info">

          <h2>Ügyfélszolgálat:</h2>
          <ul>
            <li>H 7.30-18.00</li>
            <li>K-Cs 7.30-16.00</li>
            <li>P 7.30-13:30</li>
            <li>Sz-V Zárva</li>
          </ul>

          <h2>Ügyintéző:</h2>
          <ul>
            <li>Kása Attila</li>
          </ul>

          <h2>Elérhetőség:</h2>
          <ul>
            <li><a href="tel: +36 59/520-213">59/520-213</a></li>
            <li><a href="tel: +36 20/960-8252">20/960-8252</a></li>
          </ul>

        </div>

        <div id="activities-waste-img"></div>

      </header>

      <div id="activities-waste-text">

        <div>
          <p>
            A <b>folyékony hulladékszállítást</b> Mercedes típusú, osztott tartályos csatornatisztító és szippantó felépítménnyel rendelkező gépjárművel biztosítjuk.<br/>A szippantási térfogat maximum 4 m³, csövezési lehetőség 25 fm.
          </p>

          {/* <p>
            A lakosságnál és gazdálkodó szervezeteknél keletkező <b>komposztálható szerves hulladékokat</b> (gally, fű, falevél, stb.) GORE technológiával komposztáljuk, és saját parkgondozási tevékenységünkhöz felhasználjuk. A GORE technológia lényege, hogy az előkezelt szerves hulladékot takarjuk, és az oxigént légbefúvással biztosítjuk. Jelenleg e tevékenységünket 2012-ben elvégzett utóérlelő tér, csapadék valamint csurgalékvíz elvezető rendszer kialakításának köszönhetően üzemeltetni tudjuk.<br/>A zavartalan üzemeltetés és jó minőségű komposzt előállítása érdekében <br/>az irányító rendszer javítását kell elvégezni.
          </p> */}

          <p>
            A <b>120 l-es</b> és <b>1100 l-es</b> konténerek forgalmazását is végezzük.
          </p>
          
          <p>
            A következőkben felsorolt engedélyekkel rendelkezünk:<br/>
            - Országos nem veszélyes hulladék szállítás és kereskedelem<br/>
            - Hulladékkezelő telepre vonatkozó gyűjtési, kezelési, hasznosítási engedély<br/>
            - Központi telephelyre vonatkozó nem veszélyes hulladék gyűjtési, kezelési,<br/>
            - Nem közművel összegyűjtött háztartási szennyvíz begyűjtési tevékenység nyilvántartásba vétele
          </p>

        </div>

        <div>

          <p>
            A Hulladéklerakó azon szilárd hulladéklerakó részlegén, ahol korábban kommunális hulladék elhelyezése nem történt, inert hulladéklerakó részleget alakítottunk ki. A keletkező inert hulladékot így nem kell nagy távolságra szállítani, a hulladéklerakó üzemeltetése továbbra is folyamatos és költséghatékony a lakosság szempontjából. A keletkező inert hulladékot (építési törmelék) jellemzően 3-5-8 m³-es konténerekbe gyűjtve szállítjuk az inert hulladéklerakóra. A beszállított inert hulladékokat a terület kialakítására hasznosítjuk, valamint értékes nyersanyagot szándékozunk visszanyerni.
          </p>

        </div>

      </div>

    </section>
  );
};

export default ActivitiesWaste;